export default __webpack_public_path__ + "static/media/contra_transfer.c32c605a.svg";